var _rect, _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 59,
    viewBox: "0 0 180 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 179,
    height: 58,
    stroke: "#1B1A1F",
    vectorEffect: "non-scaling-stroke"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 29,
    x2: 179,
    y2: 29,
    stroke: "#1B1A1F",
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1099 7.375C21.265 7.375 24.7018 9.65648 24.8629 13.0522H21.8557C21.6946 11.036 19.6003 9.86871 16.1636 9.86871C12.5657 9.86871 10.2029 11.8318 10.2029 15.0153C10.2029 18.1987 12.5657 20.1619 16.1099 20.1619C19.3318 20.1619 21.802 18.8885 22.1242 16.7131H13.9082V14.5378H25.0777V22.3372H22.6075L22.8223 18.9415H22.6075C21.265 21.7005 18.6874 22.6556 16.0025 22.6556C10.6862 22.6556 7.14209 19.5782 7.14209 15.0153C7.19579 10.4523 10.7399 7.375 16.1099 7.375Z",
    fill: "#1B1A1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9775 7.7464H42.2615V10.2401H30.9847V13.4236H41.0265V15.705H30.9847V19.8435H42.2615V22.3903H27.9775V7.7464Z",
    fill: "#1B1A1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1611 7.7464H47.8998L59.0155 18.2518V7.7464H62.0227V22.3903H59.2303L48.1683 11.8318V22.3903H45.1611V7.7464Z",
    fill: "#1B1A1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3521 7.7464H79.6361V10.2401H68.3592V13.4236H78.401V15.705H68.3592V19.8435H79.6361V22.3903H65.3521V7.7464Z",
    fill: "#1B1A1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5361 7.7464H94.1889C97.2497 7.7464 98.9681 9.39118 98.9681 11.6196C98.9681 13.9541 96.9812 15.2806 94.1889 15.2806H92.6316V15.3336C96.1221 15.5459 97.5719 17.6151 100.096 22.3372H96.6053C93.8667 17.4559 93.1149 16.1295 90.4836 16.1295H85.5433V22.3372H82.5361V7.7464ZM93.4371 13.7419C95.2092 13.7419 95.9073 13.1052 95.9073 12.0441C95.9073 10.7707 95.1555 10.187 93.4371 10.187H85.4896V13.7419H93.4371Z",
    fill: "#1B1A1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.869 7.7464H113.52L122.542 22.3903H119.051L117.225 19.3129H106.163L104.338 22.3903H100.847L109.869 7.7464ZM115.776 16.7662L111.694 9.81564L107.613 16.7662H115.776Z",
    fill: "#1B1A1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.247 10.2401H119.642V7.7464H135.806V10.2401H129.254V22.3903H126.247V10.2401Z",
    fill: "#1B1A1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.752 15.0684C135.752 10.4524 139.296 7.42807 144.666 7.42807C150.036 7.42807 153.58 10.5054 153.58 15.0684C153.58 19.6844 149.982 22.7086 144.666 22.7086C139.296 22.7086 135.752 19.6313 135.752 15.0684ZM150.573 15.0684C150.573 11.8849 148.21 9.92178 144.666 9.92178C141.122 9.92178 138.759 11.8849 138.759 15.0684C138.759 18.2518 141.122 20.2149 144.666 20.2149C148.21 20.2149 150.573 18.2518 150.573 15.0684Z",
    fill: "#1B1A1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.157 7.7464H167.81C170.871 7.7464 172.589 9.39118 172.589 11.6196C172.589 13.9541 170.602 15.2806 167.81 15.2806H166.253V15.3336C169.743 15.5459 171.193 17.6151 173.717 22.3372H170.226C167.488 17.4559 166.736 16.1295 164.105 16.1295H159.164V22.3372H156.157V7.7464ZM167.058 13.7419C168.83 13.7419 169.528 13.1052 169.528 12.0441C169.528 10.7707 168.777 10.187 167.058 10.187H159.111V13.7419H167.058Z",
    fill: "#1B1A1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.426 49.4496L168.347 39.1034H156.587V36.6097H173.126V38.4137L161.259 48.7599H173.341V51.2536H156.426V49.4496Z",
    fill: "#1B1A1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a6ab974717361dc8055913adc28028b5.svg";
export { ForwardRef as ReactComponent };